import { Trash2 } from "lucide-react"; // Importa el ícono de eliminar de Lucide
import { useNavigate } from "react-router-dom";

const secondaryNavigation = [
  { name: 'Cuenta', href: '/admin/settings', current: false },
  { name: 'Notificaciones', href: '/admin/notifications', current: true },
  { name: 'Calendario', href: '/admin/calendly', current: false },
  { name: 'Equipos', href: '#', current: false },
  { name: 'Integraciones', href: '#', current: false },
]

export default function Notifications() {
  const handleDeleteAllNotifications = () => {
    // Aquí puedes agregar la lógica para eliminar todas las notificaciones
    console.log("Eliminar todas las notificaciones");
  };

  const navigate = useNavigate()

  return (
    <div className="font-poppins sm:p-4 p-4 text-text bg-background">
      <header className="border-b border-gray-200 mb-8">
          {/* Navegación secundaria */}
          <nav className="flex py-4">
            <ul
              
              className="flex sm:w-full w-[200px]  flex-none sm:gap-x-6 gap-x-3 sm:px-4 text-sm font-semibold text-text  lg:px-8"
            >
              {secondaryNavigation.map((item) => (
                <li className='text-xs sm:text-base' key={item.name}>
                  <button onClick={() => navigate(`${item.href}`) } className={item.current ? 'text-indigo-600' : ''}>
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </nav>
        </header>
      {/* Encabezado */}
      <div className="py-4 px-6 bg-background rounded-lg shadow-sm border border-gray-200 flex justify-between items-center">
        <h1 className="text-2xl font-semibold text-text">Notificaciones</h1>
        <button
          onClick={handleDeleteAllNotifications}
          className="text-red-500 hover:text-red-700 text-sm flex items-center"
        >
          <Trash2 className="h-5 w-5 mr-2" /> Eliminar todas
        </button>
      </div>

      {/* Lista de notificaciones */}
      <div className="mt-4 space-y-4">
        {[
          { initials: 'RS', name: 'Rodrigo Silva Bilbao', email: 'rod13@gmail.com', phone: '+52 3312456738', prospect: 'Leyendas de Guadalajara', description: 'Sera un podcast sobre historias veridicas sobre Guadalajara', newIdea: 'Si', timestamp: '2025-02-10 11:51:00 PM' },
          { initials: 'AG', name: 'Ana María González', email: 'ana.maria@gmail.com', phone: '+52 3321457890', prospect: 'Festival Internacional de Cine', description: 'Un evento anual de cine con proyecciones y charlas.', newIdea: 'No', timestamp: '2025-02-12 09:10:00 AM' },
          { initials: 'AS', name: 'Alberto Sánchez Rivas', email: 'alberto.sr@example.com', phone: '+52 3334678910', prospect: 'Gastronomía Mexicana', description: 'Un proyecto culinario para mostrar la cocina tradicional mexicana.', newIdea: 'Sí', timestamp: '2025-02-11 03:15:00 PM' },
          { initials: 'MR', name: 'Marta Rodríguez López', email: 'marta.rodriguez@outlook.com', phone: '+52 3345789043', prospect: 'Talleres de Pintura', description: 'Clases de pintura para niños y adultos, impartidos por artistas locales.', newIdea: 'No', timestamp: '2025-02-10 05:30:00 PM' },
          { initials: 'CF', name: 'Carlos Fernández Díaz', email: 'carlosfdz@hotmail.com', phone: '+52 3310987654', prospect: 'Escape Room', description: 'Una experiencia de escape interactivo para grupos de amigos.', newIdea: 'Sí', timestamp: '2025-02-09 01:00:00 AM' },
          { initials: 'JP', name: 'Javier Pérez Martínez', email: 'javierpm@correo.com', phone: '+52 3356789012', prospect: 'Música Electrónica', description: 'Un proyecto musical basado en la mezcla de géneros electrónicos innovadores.', newIdea: 'No', timestamp: '2025-02-08 04:20:00 PM' },
        ].map((notification, index) => (
          <div
            key={index}
            className="flex flex-col sm:flex-row bg-background  transition-colors p-4 rounded-lg shadow-sm border border-gray-200"
          >
            {/* Iniciales con color */}
            <div className="flex items-center justify-center sm:justify-start mb-4 sm:mb-0 sm:mr-4">
              <button
                className={`w-10 h-10 flex items-center justify-center rounded-md text-white font-semibold ${getColor(notification.initials)}`}
              >
                {notification.initials}
              </button>
            </div>

            {/* Detalles de la notificación */}
            <div className="flex-1">
              <h2 className="text-lg font-semibold text-text">{notification.name}</h2>
              <p className="text-sm text-text">
                <span className="font-semibold">Email:</span> {notification.email}
              </p>
              <p className="text-sm text-text">
                <span className="font-semibold">Phone:</span> {notification.phone}
              </p>
              <p className="text-sm text-text">
                <span className="font-semibold">Prospecto:</span> {notification.prospect}
              </p>
              <p className="text-sm text-text">
                <span className="font-semibold">Descripción:</span> {notification.description}
              </p>
              <p className="text-sm text-text">
                <span className="font-semibold">Nueva idea:</span> {notification.newIdea}
              </p>
            </div>

            {/* Timestamp y botón de eliminar */}
            <div className="flex flex-col sm:items-end mt-4 sm:mt-0 sm:ml-4">
              <p className="text-xs sm:text-sm text-text mb-2 sm:mb-0">{notification.timestamp}</p>
              <button
                className="text-red-400 hover:text-red-600 sm:hover:bg-red-50 p-2 rounded-full transition-colors sm:mt-10 sm:ml-0 ml-40"
                onClick={() => {
                  console.log("Eliminar notificación:", notification.name);
                }}
              >
                <Trash2 className="h-5 w-5 sm:h-7 sm:w-7" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function getColor(initials) {
  const colorMap = {
    RS: 'bg-blue-500',
    AG: 'bg-pink-500',
    AS: 'bg-orange-500',
    MR: 'bg-purple-500',
    CF: 'bg-green-500',
    JP: 'bg-red-500',
  };
  return colorMap[initials] || 'bg-gray-500';
}